module.exports = __webpack_public_path__ + "static/media/7_elefant.4b77b0e0.png";